import React, { useState, useEffect, useRef, useMemo } from 'react';

import { translatedMessage } from '../../service/LanguageService';
import { UserService } from '../../service/UserService';

import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import WorkExperienceListComponent from '../../components/profile/WorkExperienceListComponent';
import { useParams } from 'react-router-dom';
import useNavProps from '../../hooks/useNavProps';
import ProfileToolbar from './ProfileToolbar';

const ProfileWorkExperience = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [user, setUser] = useState();
    const [experienceList, setExperienceList] = useState(null);
    const { userIdParam } = useParams();
    const { setNavPropsValue } = useNavProps();

    const toast = useRef(null);

    const userService = useMemo(() => new UserService(), []);

    useEffect(() => {
        setIsLoading(true)

        const getProfile = async () => {
            await userService.getUserProfile(userIdParam)
                .then(async response => {
                    setUser(response)
                    setNavPropsValue('users', response.id, response.fullName)

                    await getExperience()
                })
                .catch(error => {
                    toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 })
                    setIsLoading(false)
                })
        }

        const getExperience = async () => {
            await userService.getUserProfileWorkExperience(userIdParam)
                .then(experienceRespone => {
                    setExperienceList(experienceRespone)
                    setIsLoading(false)
                })
                .catch(error => toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }))
        }

        getProfile()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userService, userIdParam]);
 


    if (isLoading) {
        return (
            <div className='w-full flex align-items-center'>
                <Toast ref={toast}></Toast>
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <div className="grid h-full">
                <Toast ref={toast}></Toast>
                <div className="col-12">
                    <div className="card h-full">
                        <ProfileToolbar user={user} code="WORK" />

                        <div className='w-full text-align-left'>
                            <h5>{translatedMessage("profile.workExperience")}</h5>
                        </div>

                        <WorkExperienceListComponent 
                            experience={experienceList} 
                            onListUpdate={(list) => setExperienceList(list)} 
                            hasExportButton={true} 
                            updateFields={false}
                            readOnly={true}
                        />
                    </div>
                </div>
            </div>
        );
    }
};

export default ProfileWorkExperience;
